module.exports = __webpack_public_path__ + "img/zsw_shuiyin666.03fa23dd.png";